import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getReferrals = (paginate) => {
  return http.get(
    `${getBaseUrl()}/referral?${paginate}`
  );
};

export const getPersonReferral = () => {
  return http.get(
    `${getBaseUrl()}/person_referral`
  );
};


export const sendPersonReferralLink = () => {
  return http.get(
    `${getBaseUrl()}/send_referral_link`
  );
};


export const updateReferral = (data) => {
  return http.put(
    `${getBaseUrl()}/referral/${data.id}/${data.referral_config_id}`,
  );
};
